import { render, staticRenderFns } from "./sub-require-info.vue?vue&type=template&id=0d7b80d2&scoped=true&"
import script from "./sub-require-info.vue?vue&type=script&lang=js&"
export * from "./sub-require-info.vue?vue&type=script&lang=js&"
import style0 from "./sub-require-info.vue?vue&type=style&index=0&id=0d7b80d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7b80d2",
  null
  
)

export default component.exports